export default __webpack_public_path__ + "static/assets/212941173b83fbc5a4043ee9f6f79072.png";